var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7006 7.22347H14.3413V6.00024H2V9.62491C3.38898 9.71737 4.49054 10.8766 4.49054 12.2889C4.49054 13.7011 3.38874 14.8604 2 14.9531V18.5777H14.3413V17.3394H14.7006V18.5777H22V6H14.7006V7.22347ZM14.7006 15.8625H14.3413V14.4596H14.7006V15.8625ZM14.7006 12.9828H14.3413V11.5799H14.7006V12.9828ZM14.7006 10.1032H14.3413V8.70036H14.7006V10.1032Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickestIcon);
export default __webpack_public_path__ + "static/media/tickestIcon.b35ec65c7e382d62ab9ee3f2334bfdf1.svg";
export { ForwardRef as ReactComponent };